<template>
  <a-select
    v-model="selected_code"
    :placeholder="placeholder || $t('结算方式')"
    :disabled="disabled"
    style="width: 100%"
    :allow-clear="allowClear"
    @change="handleChange"
  >
    <a-select-option v-for="item in list" :key="item.code" :value="item.code">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'

export default {
  name: 'SelectSettlementMethod',
  model: {
    prop: 'code',
    event: 'update:code',
  },
  props: {
    // 当前单据的 docType，如 ReceiptNote / PayableOrder / ReceivableOrder 等
    docType: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    selected_code: {
      get() {
        return this.code
      },
      set(val) {
        this.$emit('update:code', val)
      },
    },
  },
  watch: {
    docType: {
      handler() {
        this.fetchList()
      },
      immediate: true,
    },
  },
  methods: {
    async fetchList() {
      // 1. 先尝试获取自定义字段配置的可选值 (如果传了 docType)
      if (this.docType) {
        try {
          const fieldRes = await http({
            url: api.getFinanceDocumentFieldValue,
            data: {
              financeDocumentCode: this.docType,
              fieldCode: `${this.docType}.settlementMethod`,
            },
          })
          if (fieldRes.result?.length > 0) {
            this.list = fieldRes.result.map((item) => ({
              code: item.value_code,
              name: item.value_name,
            }))
            return
          }
        } catch (e) {
          console.error('获取自定义结算方式失败', e)
        }
      }

      // 2. 如果没有自定义配置，则使用原逻辑
      const res = await http({
        url: api.getSettlementMethodList,
        data: {
          pageNo: 1,
          pageSize: 1000,
        },
      })
      this.list = (res.result?.list || []).map((item) => ({
        code: item.code,
        name: item.name,
      }))
    },
    handleChange(val) {
      const item = this.list.find((i) => i.code === val)
      this.$emit('change', val, item)
    },
  },
}
</script>
